import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "subMenus", "title", "link", "level", "paddingX", "paddingY", "withBackground", "collapsible", "activeLink", "activateParent"];
import clsx from "clsx";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "./link";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Menu = _ref => {
  var {
    subMenus,
    title,
    link,
    level = 0,
    paddingX = 2,
    paddingY = 4,
    withBackground = true,
    collapsible = true,
    activeLink,
    activateParent
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var [paddingXClass, setPaddingXClass] = useState("pl-2");
  var [paddingYClass, setPaddingYClass] = useState("py-4");
  var [bgClass, setBgClass] = useState("");
  var [isOpen, setIsOpen] = useState(!collapsible);
  var [localActiveLink, setLocalActiveLink] = useState(activeLink);
  var [isActive, setIsActive] = useState(false);
  var router = useRouter();
  var clearedLink = useMemo(() => cleanHref(link), [link]); // update active link from url or parent

  useEffect(() => {
    var newActive = activeLink || router.asPath;

    if (localActiveLink !== newActive) {
      setLocalActiveLink(newActive); // open parent menu if active

      if (newActive === clearedLink && activateParent) {
        activateParent();
      }

      setIsActive(newActive === clearedLink);
    }
  }, [router.pathname, activeLink]);
  useEffect(() => {
    if (isOpen && activateParent) {
      activateParent();
    }
  }, [isOpen]);
  useEffect(() => {
    if (activeLink !== localActiveLink) {
      setLocalActiveLink(activeLink ? activeLink : window.location.pathname);
    }
  }, [activeLink]);
  useEffect(() => {
    var paddings = [["pl-4", "pl-5", "pl-6", "pl-7", "pl-8", "pl-9", "pl-10", "pl-11"], ["pl-4", "pl-6", "pl-8", "pl-10", "pl-12", "pl-14", "pl-16", "pl-18"], ["pl-4", "pl-7", "pl-10", "pl-13", "pl-16", "pl-19", "pl-22", "pl-25"], ["pl-4", "pl-8", "pl-12", "pl-16", "pl-20", "pl-24", "pl-28", "pl-32"]];
    var levelsPadding = paddings[paddingX] ? paddings[paddingX] : paddings[0];
    setPaddingXClass(levelsPadding[level] ? levelsPadding[level] : levelsPadding[0]);
  }, [paddingX, level]);
  useEffect(() => {
    var paddings = ["py-0", "py-1", "py-2", "py-3", "py-4", "py-5"];
    setPaddingYClass(paddings[paddingY] ? paddings[paddingY] : "py-4");
  }, [paddingY]);
  useEffect(() => {
    if (!withBackground) {
      setBgClass('');
      return;
    }

    switch (level) {
      case 0:
      case undefined:
        setBgClass('bg-[#f3f3f3]');
        break;

      case 1:
        setBgClass('bg-[#f9f9f9]');
        break;

      case 2:
        setBgClass('bg-[#fdfdfd]');
        break;

      case 3:
        setBgClass('bg-[#fdfdfd]');
        break;

      default:
        setBgClass('bg-[#f3f3f3]');
        break;
    }
  }, [level, withBackground]);
  var toggle = useCallback(() => {
    if (collapsible) {
      setIsOpen(!isOpen);
    }
  }, [collapsible, isOpen, setIsOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [title && /*#__PURE__*/_jsxs("div", {
      onClick: toggle,
      className: clsx("flex w-full items-center pr-3 w-full cursor-pointer  border-l-transparent hover:border-l-ccq-yellow-500", paddingYClass, paddingXClass, bgClass, {
        "border-l-4": withBackground
      }, {
        "!border-l-ccq-yellow": withBackground && isActive && !(isOpen && subMenus && subMenus.length)
      }),
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex-1",
        children: clearedLink && !(collapsible && subMenus && !!subMenus.length) ? /*#__PURE__*/_jsx(Link, {
          href: clearedLink,
          className: "no-underline font-normal",
          children: title
        }) : title
      }), collapsible && subMenus && !!subMenus.length && /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        className: clsx("transition duration-150 ease-in-out w-3 h-3 tracking-normal shrink", {
          "rotate-180": isOpen
        }),
        children: /*#__PURE__*/_jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
        })
      })]
    }), subMenus && !!subMenus.length && /*#__PURE__*/_jsx("div", {
      className: isOpen ? "" : "hidden",
      children: subMenus == null ? void 0 : subMenus.map((subMenu, index) => /*#__PURE__*/_jsx(Menu, _extends({}, subMenu, {
        withBackground: withBackground || subMenu.withBackground,
        activeLink: localActiveLink,
        activateParent: () => {
          setIsOpen(true);
          setIsActive(true);
        },
        paddingX: paddingX || subMenu.paddingX,
        paddingY: paddingY || subMenu.paddingY,
        collapsible: collapsible || subMenu.collapsible,
        level: (level || 0) + 1
      }), index))
    })]
  });
};

var cleanHref = href => {
  var variant = process.env.NEXT_PUBLIC_VARIANT;
  if (!href) return "";
  var url = "";

  if (typeof href === "string") {
    url = href; // If the link is an email we want to return early with the mailto: href.
  } else if (href.linktype === "email") {
    return "mailto:" + (href.cached_url || href.url || href.email);
  } else {
    if (!href.cached_url && !href.url) return "";
    url = href.cached_url || href.url;
  }

  if (url.startsWith("http")) {
    return url;
  } // remove the first "/" from the URL


  if (url.startsWith("/")) {
    url = url.slice(1);
  } // if a variant is detected, slice the variant


  if (variant) {
    if (url.startsWith(variant)) {
      url = url.slice(variant.length);
      return url;
    }
  } // re-add the "/" to confirm with href standards


  return "/" + url;
};
//# sourceMappingURL=menu.js.map